var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgK(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127.53,
    height: 200,
    viewBox: "0 0 127.53 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.6877 -60.676)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2444 0 0 1.2444 -1696.7 -496.52)",
    stroke: "#000",
    strokeLinecap: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1367.5 452.77-0.375 126.36",
    fill: "none",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1456.5 454.11c-32.141 1.0124-79.387 37.458-87.422 67.059-8.0352 29.6 24.641 29.6 24.641 29.6l16.392-11.281 1.982 26.563s8.2494 0.24107 14.57 4.9655 6.321 11.522 6.321 11.522l26.57-10.172s-0.75 14.414-5.089 19.476",
    fill: "none",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1419.1,
    cy: 601.34,
    r: 3.8123,
    strokeWidth: 6.682,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1396.9,
    cy: 586.31,
    r: 3.8123,
    strokeWidth: 6.682,
    style: {
      paintOrder: "stroke fill markers"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.25 0 0 .25 -121.75 -75.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4311 0 0 1.4311 -483.86 -174.02)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.0191 .25015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m964.11 439.24c-0.85709 28.684-86.405 28.588-91.065-0.38566-4.6604-28.974 33.051-34.952 33.051-34.952s-34.23-7.1831-33.319-26.611c0.91065-19.428 9.6422-22.706 9.6422-22.706l9.3208-21.983 14.463 17.162s9.3208-3.5675 15.16-3.5675c5.8389 0 12.588 5.1102 12.588 5.1102l17.195-20.392s8.8922 12.342 7.8209 19.573",
    fill: "none",
    stroke: "#030000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 908.3,
    cy: 378.56,
    r: 3.8123,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.682,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 934.86,
    cy: 378.43,
    r: 3.8123,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.682,
    style: {
      paintOrder: "stroke fill markers"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.33389 0 0 .33389 -90.356 -334.92)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145.32 387.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.4 -387.33)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m806.55 1036.5-10.231-23.14-14.678 19.862s-5.5175-3.5675-14.785-3.4229-16.552 5.6887-16.552 5.6887-14.41-35.193-61.442-34.759",
    strokeLinejoin: "round",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m729.11 1140.5-0.20575-127.42"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 779.71,
    cy: 1062.8,
    r: 3.8123,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.682,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.42,
    cy: 1062.9,
    r: 3.8123,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.682,
    style: {
      paintOrder: "stroke fill markers"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK);
export default __webpack_public_path__ + "static/media/k.3ac18613776069bd12c3ecee7f1c6b8b.svg";
export { ForwardRef as ReactComponent };